import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import type { CreateAnnotationRequest } from "../types";
import { invalidateEvalStewardQueries } from "../utils/invalidateEvalStewardQueries";

export function useCreateAnnotation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CreateAnnotationRequest) =>
      api.createEvalAnnotation(body),
    onSuccess: (annotation) => {
      const { source_ref: sourceRef } = annotation;
      invalidateEvalStewardQueries(
        queryClient,
        {
          workspaceId: sourceRef.workspace_id,
          threadId: sourceRef.thread_id,
          assistantMessageIndex: sourceRef.assistant_message_index,
        },
        annotation.annotation_id,
      );
    },
  });
}
